module.exports = __webpack_public_path__ + "assets/svg/Icons/32/birthday-blue-c87150.svg";